import React, { useContext } from 'react';
import {
  TotalValuesContainer,
  TotalValues01,
  TableHeading,
  Text,
  Text1,
  NavigationCross,
} from './DeltaTableTotalValues.style';
import { AppContext } from '../../../../../../Context/AppContext';
import { NCF_DASHBOARD_QTY_DECIMAL_PLACES } from '../../../../../../api/constants';

const DeltaTableTotalValues = () => {
  const { state: reconState } = useContext(AppContext).reconReports;
  const {
    CPM: { TOTAL_VOLUME: CPM_TOTAL_VOLUME, TOTAL_COUNT: CPM_TOTAL_COUNT },
    ETRM: { TOTAL_VOLUME: ETRM_TOTAL_VOLUME, TOTAL_COUNT: ETRM_TOTAL_COUNT },
    DELTA: { TOTAL_VOLUME: DELTA_TOTAL_VOLUME, TOTAL_COUNT: DELTA_TOTAL_COUNT },
  } = reconState.reconReportVolumeTableData.totals;

  const { uom } = reconState.ReconfilteredValues;

  const formatDecimalValue = (value: number) => value.toFixed(NCF_DASHBOARD_QTY_DECIMAL_PLACES);

  return (
    <TotalValuesContainer>
      <TotalValues01>
        <TableHeading>
          <Text>CPM Total Volume:</Text>
          <Text1>
            {formatDecimalValue(CPM_TOTAL_VOLUME)} {uom}
          </Text1>
        </TableHeading>
        <TableHeading>
          <Text>ETRM Total Volume:</Text>
          <Text1>
            {formatDecimalValue(ETRM_TOTAL_VOLUME)} {uom}
          </Text1>
        </TableHeading>
        <TableHeading>
          <Text>Delta Total Volume:</Text>
          <Text1>
            {formatDecimalValue(DELTA_TOTAL_VOLUME)} {uom}
          </Text1>
        </TableHeading>
        <TableHeading>
          <Text>CPM Total Count:</Text>
          <Text1>{CPM_TOTAL_COUNT}</Text1>
        </TableHeading>
        <TableHeading>
          <Text>ETRM Total Count:</Text>
          <Text1>{ETRM_TOTAL_COUNT}</Text1>
        </TableHeading>
        <TableHeading>
          <Text>Delta Total Count:</Text>
          <Text1>{DELTA_TOTAL_COUNT}</Text1>
        </TableHeading>
        <NavigationCross />
      </TotalValues01>
    </TotalValuesContainer>
  );
};

export default DeltaTableTotalValues;
